<template>
  <div class="chart" :id="chartID"></div>
</template>

<script>
import P5 from 'p5';
import gsap from "gsap";

export default {
    props: ["src", "id", "data", "en"],

    data() {
        return {
            p5: {},
            chartID: 'chart_'+ this.id,
            dataEn: this.en
        }
    },
    // vue-p5 data binding referance: https://aatishb.com/p5-vue-starter/
    methods: {
        
        // loadScript from https://stackoverflow.com/a/950146
        loadScript(url, callback) {
            let head = document.head;
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;

            // Then bind the event to the callback function.
            // There are several events for cross browser compatibility.
            script.onreadystatechange = callback;
            script.onload = callback;

            // Fire the loading
            head.appendChild(script);
        },

        loadSketch() {
            this.p5 = new P5(sketch(this),  this.chartID);
        }
    },

    watch: {
        data: {
            handler: function() {
                if(this.p5.dataChanged) {
                    this.p5.dataChanged(this.data);
                }
            },
            deep: true
        },

        en: {
            handler: function(newVal) {
                if(this.p5.lanChanged) {
                     this.p5.lanChanged();
                }
            },
            deep: true
          
        }

    },

    mounted() {
        this.loadScript(this.src, this.loadSketch);
    }

}
</script>

<style>

</style>